import React, { useState, useEffect } from "react";

const API_BASE = "https://adria.terrier-ule.ts.net";

// URL에서 token 파라미터 추출
function getToken() {
  const params = new URLSearchParams(window.location.search);
  return params.get("token") || "";
}

const DOOR_ICONS = {
  "MAIN_DOOR": "🏢",
};

export default function DoorOpen() {
  const [info,    setInfo]    = useState(null);   // { room_no, user_name, doors, expires_at }
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(true);
  const [opening, setOpening] = useState(null);  // 열고 있는 door_id
  const [opened,  setOpened]  = useState({});    // { door_id: true }

  const token = getToken();

  useEffect(() => {
    if (!token) { setError("유효하지 않은 링크입니다"); setLoading(false); return; }
    fetch(`${API_BASE}/api/open?token=${token}`)
      .then(async res => {
        const data = await res.json();
        if (!res.ok) setError(data.detail || "오류가 발생했습니다");
        else setInfo(data);
      })
      .catch(() => setError("서버에 연결할 수 없습니다"))
      .finally(() => setLoading(false));
  }, []);

  const openDoor = async (doorId) => {
    setOpening(doorId);
    try {
      const res = await fetch(`${API_BASE}/api/open?token=${token}&door_id=${doorId}`, {
        method: "POST",
      });
      const data = await res.json();
      if (res.ok) {
        setOpened(prev => ({ ...prev, [doorId]: true }));
        setTimeout(() => setOpened(prev => ({ ...prev, [doorId]: false })), 3000);
      } else {
        alert(data.detail || "문 열기 실패");
      }
    } catch {
      alert("서버에 연결할 수 없습니다");
    } finally {
      setOpening(null);
    }
  };

  const styles = {
    wrap: {
      minHeight: "100vh",
      backgroundColor: "#f3f4f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      fontFamily: "sans-serif",
    },
    card: {
      backgroundColor: "#fff",
      borderRadius: "20px",
      padding: "32px 24px",
      maxWidth: "360px",
      width: "100%",
      boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      textAlign: "center",
    },
    title: { fontSize: "22px", fontWeight: "bold", color: "#1f2937", marginBottom: "4px" },
    sub:   { fontSize: "13px", color: "#6b7280", marginBottom: "28px" },
    doorBtn: (isOpened, isOpening) => ({
      width: "100%",
      padding: "18px",
      marginBottom: "12px",
      borderRadius: "14px",
      border: "none",
      cursor: isOpening ? "not-allowed" : "pointer",
      backgroundColor: isOpened ? "#d1fae5" : isOpening ? "#e0e7ff" : "#4f46e5",
      color: isOpened ? "#065f46" : isOpening ? "#4f46e5" : "#fff",
      fontSize: "16px",
      fontWeight: "bold",
      transition: "all 0.2s",
      boxShadow: isOpened ? "none" : "0 4px 12px rgba(79,70,229,0.25)",
    }),
    expires: { fontSize: "11px", color: "#9ca3af", marginTop: "20px" },
    errorBox: {
      backgroundColor: "#fef2f2",
      border: "1px solid #fecaca",
      borderRadius: "12px",
      padding: "20px",
      color: "#b91c1c",
      fontSize: "14px",
    },
  };

  if (loading) return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={{ fontSize: "32px", marginBottom: "12px" }}>🔒</div>
        <div style={{ color: "#6b7280", fontSize: "14px" }}>확인 중...</div>
      </div>
    </div>
  );

  if (error) return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={{ fontSize: "40px", marginBottom: "16px" }}>🚫</div>
        <div style={styles.errorBox}>{error}</div>
      </div>
    </div>
  );

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={{ fontSize: "40px", marginBottom: "8px" }}>🏠</div>
        <div style={styles.title}>{info.room_no}호</div>
        <div style={styles.sub}>{info.user_name} 님 안녕하세요</div>

        {info.doors.map(door => {
          const isOpened  = !!opened[door.door_id];
          const isOpening = opening === door.door_id;
          const icon = DOOR_ICONS[door.door_id] || "🚪";
          return (
            <button
              key={door.door_id}
              onClick={() => openDoor(door.door_id)}
              disabled={isOpening}
              style={styles.doorBtn(isOpened, isOpening)}
            >
              {isOpened
                ? `✅ ${door.label} 열림!`
                : isOpening
                  ? `${icon} 열리는 중...`
                  : `${icon} ${door.label} 열기`}
            </button>
          );
        })}

        <div style={styles.expires}>
          만료: {info.expires_at?.slice(0, 10)}
        </div>
      </div>
    </div>
  );
}
